import { BASE_CURRENCY_DIVISION } from '@tundr/i18n';

export const CREATE_MEAL_VOUCHER_ORDER_WIZARD_NAMESPACE =
  'meal-voucher-create-order';

export const CREATE_MEAL_VOUCHER_ORDER_STEPS = {
  SELECT_EMPLOYEES: 'select-employees',
  SETUP: 'setup',
  CONFIRM: 'confirm',
  RECAP: 'recap',
} as const;

export const EMPLOYEES_WITH_CARD_FILTERS_NAMESPACE =
  'hr/meal-voucher-order/employees-with-card';

export const SETUP_STEP_PAGE_SIZE = 25;

export const MIN_MEAL_VOUCHER_VALUE_IN_EUROS = 0.5;

export const MIN_MEAL_VOUCHER_VALUE =
  MIN_MEAL_VOUCHER_VALUE_IN_EUROS * BASE_CURRENCY_DIVISION;
